export default {
    name: 'CustomTheme',
    prefix: 'customTheme',
    //TM-Branding-START
    rootStyle: {
        //Typography branding
        '--GW-FONT-SANS-SERIF': 'Helvetica,Arial,sans-serif',
        //color theme for menu box
        '--GW-COLOR-BRAND-3': '#9f1a65',
        '--GW-COLOR-BRAND-3-CONTRAST': 'var(--GW-COLOR-LIGHT-CONTRAST)',
        '--GW-COLOR-BRAND-3-HOVER': '#aba9ab',
        '--GW-COLOR-BRAND-3-ACTIVE': '#9f1a65',
        '--GW-COLOR-HIGHLIGHT-2': 'white',
        //color theme for button
        '--GW-COLOR-BRAND-1': '#007852',
        '--GW-COLOR-BRAND-1-CONTRAST': 'var(--GW-COLOR-DARK-CONTRAST)',
        '--GW-COLOR-BRAND-1-HOVER': '#007852',
        '--GW-COLOR-BRAND-1-ACTIVE': '#70a087',
        '--GW-COLOR-BRAND-1-GRADIENT': '#007852',
        '--GW-COLOR-BRAND-1-GRADIENT-HOVER': '#007852',
        '--GW-COLOR-BRAND-1-GRADIENT-ACTIVE': '#70a087',

         '--GW-COLOR-FOCUS-1': 'none',//'var(--GW-COLOR-BRAND-1-ACTIVE)',  //use for accordian focus box
        // '--GW-COLOR-FOCUS-1-CONTRAST': 'var(--GW-COLOR-LIGHT-CONTRAST)',
        // '--GW-COLOR-FOCUS-1-HOVER': 'var(--GW-COLOR-BRAND-1-ACTIVE)',
        // '--GW-COLOR-FOCUS-1-ACTIVE': 'var(--GW-COLOR-BRAND-1-ACTIVE)',
        //color theme for top frame
      //  '--GW-COLOR-BRAND-2': 'whitesmoke'
        '--GW-COLOR-BRAND-2-CONTRAST': 'var(--GW-COLOR-DARK-CONTRAST)',
        '--GW-COLOR-BRAND-2-HOVER': '#9f1a65',
        '--GW-COLOR-BRAND-2-ACTIVE': '#9f1a65',

        '--GW-BOX-SHADOW-FOCUS' : 'none',//'#70a087', //use for accordian focus box
        '--NEXUS-COLOR-BRAND-1': 'whitesmoke', //for top frame background and login page
        '--header-button-focus-border-size': '4px'
    },
    componentStyles: {
        ApplicationHeader: {
            applicationHeader: {
                '--application-header-header-background-color': 'var(--NEXUS-COLOR-BRAND-1)',
                'height': '70px'
            },
            applicationLogoTitleLink: {
                'width': '200px'
            },
            applicationLogo: {
                '--application-header-logo-size': '80px',
            },
            subApplicationHeader: {
                'background': '#fff',
            }
        },
         Button: {
            button: {
            '--button-hover-bg-image': 'linear-gradient(240deg, #f5f5f5 0%, #f5f5f5 100%)',
            '--button-hover-color': '#007852',
            '--button-border': 'solid',
            '--button-box-shadow': 'none',
              }
         },
        Panel: {
             panel:{
                '--panel-box-shadow' : 'none'
             }
        },
        InfoLabel : {
            neutral : {
               '--info-label-bg-color' : '#9f1a65',
                '--info-label-color' : 'var(--GW-COLOR-ALERT-INFO-CONTRAST)'
            }
        },
        Table: {
             table: {
                 'padding': 'var(--table-padding-y) 0 var(--table-padding-y) 0'
             }
        },
        FieldLabel: {
            fieldLabel: {
                '--field-label-color': 'var(--GW-COLOR-TEXT-1)'
            }
        }
    }
    //TM-Branding-END
};